// import axios from "axios";
import Properties from "../properties";
import apiClient from "../plugins/axios-instance";

const API_URL_DEVELOPMENT = "https://api.amigogroup.id/poin-gifts/restock-gifts";
const API_URL_PRODUCTION = "https://backend.amigogroup.net/poin-gift/api/restock-gifts";

export default class RestockGiftPoinAPIService {
  constructor() {}
  config = this.$session.get("jwt");
  headers = {};

  static getURL = () => {
    return Properties.BUILD_TYPE == "production" ? API_URL_PRODUCTION : API_URL_DEVELOPMENT;
  }
  static create = (gift) =>
    apiClient.post(this.getURL() + "/", gift, {
    });
}
